import { Platform } from '@/utils/platform';
import { newInvoke } from '../../QTBridge';
import { call } from '@popo-bridge/web';

export interface SnapshotParams {
  snapshotId: number;
  base64Image: string; // base64 编码的快照图片
}

/**
 *
 * @param params 回传快照
 */
export const snapshot = async (params: SnapshotParams) => {
  if (Platform.isPOPO) {
    if (Platform.isPC) {
      await newInvoke({
        methodName: 'snapshot',
        params: params,
      });
    } else {
      await call('snapshot', params);
    }
  }
};
